import Application from './Application';

window.trovitApp = new Application();
window.trovitApp.start();

export default trovitApp;
